window.BoxberryPvz = {
	callbackPvz: function (data) {
		var addr = ['#' + data.id, data.address].join(', ');

		var $container = window.VegasOrder.formOrder().find('.tab-delivery-boxberry-pvz');

		$container.find('.boxberry-content .boxberry-addr').text(addr);
		$container.find('.input-boxberry-addr').val(addr);

		$container.find('.open-boxberry-widget').hide();
		$container.find('.boxberry-content').show();

		BoxberryPvz.updatePrice();

		return false;
	},

	open: function () {
		if (typeof boxberry !== 'undefined') {
			boxberry.open(BoxberryPvz.callbackPvz);
		}
	},

	updatePrice: function () {
		var $deliveryMsgError = window.VegasOrder.formOrder().find(".tab-delivery-boxberry-pvz .msg-error");
		var $deliveryMsgSuccess = window.VegasOrder.formOrder().find(".tab-delivery-boxberry-pvz .msg-success");
		$deliveryMsgSuccess.show().text('Рассчитываем стоимость доставки...');
		$deliveryMsgError.hide();

		var params = window.VegasOrder.formOrder().serializeArray();
		$.get('/cart/order/get_boxberry_price', params, function (data) {
			$deliveryMsgError.hide();
			$deliveryMsgSuccess.hide();

			if (data.error) {
				if (data.type == 'no_delivery') {
					$deliveryMsgError
						.text('К сожалению, мы не сможем доставить заказ по данному адресу')
						.show();

					$('[data-order-sum=delivery]').html('<span class="text-danger">-</span>');
				}

				VegasOrder.disabledBoxberryPvz = true;
			} else {
				$deliveryMsgSuccess
					.text('Приблизительная стоимость доставки: ' + (data.price ? output_roubles(data.price) : 'бесплатно'))
					.show();

				VegasOrder.disabledBoxberryPvz = false;
			}

			VegasOrder.renderOrderButtons();
		});
	},
};

$(document).ready(function () {
	VegasOrder.formOrder().find('.change-boxberry-widget, .open-boxberry-widget').click(function () {
		BoxberryPvz.open();
		return false;
	});

	$('#user_address-boxberry_pvz').on('update-price', function () {
		BoxberryPvz.updatePrice();
	});
});